module.exports = __webpack_public_path__ + "static/media/mdm-icon.4305d6cf.png";